import React, { useRef } from "react";
import { useFirebase } from "../../database/FirebaseContext";
import { Timestamp } from "firebase/firestore";

function SprintForm({ closeModal, onAdd }) {
  const { addSprint } = useFirebase();

  const nameInputRef = useRef();
  const startDateInputRef = useRef();
  const endDateInputRef = useRef();
  const statusInputRef = useRef();

  const handleSubmit = (event) => {
    event.preventDefault();
    const enteredName = nameInputRef.current.value;
    const enteredStartDate = startDateInputRef.current.value;
    const enteredEndDate = endDateInputRef.current.value;
    const enteredStatus = statusInputRef.current.value;

    const startDate = new Date(enteredStartDate);
    const endDate = new Date(enteredEndDate);

    if (startDate >= endDate) {
      alert("Sprint ending date must be after starting date");
    } else {
      const formData = {
        sprintName: enteredName,
        sprintStartDate: Timestamp.fromDate(startDate),
        sprintEndDate: Timestamp.fromDate(endDate),
        sprintStatus: enteredStatus,
      };
      addSprint(formData);
      console.log(formData);
    }
  };

  return (
    // modal
    <div className="block fixed z-[1] w-full h-full overflow-auto bg-[rgba(0,0,0,0.649)] left-0 top-0">
      {/* modal content */}
      <div className="flex justify-center items-center mt-[30vh] ml-[60vh] w-[1550px]">
        {/* title */}
        <div className="text-[#ffffff] w-5/12 h-auto bg-[#3D3E44] rounded-xl">
          {/* Header for Form */}
          <div className="bg-[#9B9B9B] rounded-t-xl py-3 text-3xl text-center">
            Create Sprint
          </div>

          {/* Form Body */}
          <div className="bg-[#3D3E44] rounded-b-xl">
            <form onSubmit={handleSubmit}>
              {/* Sprint Name */}
              <div className="mt-4 flex">
                <label htmlFor="sprintName" className="pl-10 text-xl">
                  Name
                </label>
                <input
                  type="text"
                  id="sprintName"
                  name="sprintName"
                  // value="Name 1"
                  placeholder="Sprint Name..."
                  ref={nameInputRef}
                  required
                  className="bg-[#616675] ml-3 mr-7 pl-3 rounded w-full text-xl"
                />
              </div>

              {/* Sprint Start & End Date */}
              <div className="mt-4 flex">
                <div className="flex-1 flex">
                  <label
                    htmlFor="sprintStartDate"
                    className="pl-2 text-xl whitespace-nowrap"
                  >
                    Start Date
                  </label>
                  <input
                    type="date"
                    id="sprintStartDate"
                    name="sprintStartDate"
                    ref={startDateInputRef}
                    required
                    className="bg-[#616675] rounded ml-1 flex-grow mr-2 pl-2 text-xl"
                  />
                </div>

                <div className="flex-1 flex">
                  <label
                    htmlFor="sprintEndDate"
                    className="whitespace-nowrap text-xl"
                  >
                    End Date
                  </label>
                  <input
                    type="date"
                    id="sprintEndDate"
                    name="sprintEndDate"
                    ref={endDateInputRef}
                    required
                    className="bg-[#616675] rounded ml-3 flex-grow mr-7 pl-2 text-xl"
                  />
                </div>
              </div>

              {/* Sprint Status */}
              <div className="mt-4 flex">
                <label htmlFor="sprintStatus" className="pl-9 text-xl">
                  Status
                </label>
                <select
                  name="sprintStatus"
                  id="sprintStatus"
                  ref={statusInputRef}
                  required
                  className="bg-[#616675] ml-3 pl-2 w-full rounded mr-7 text-xl"
                >
                  <option value="NotStarted">Not Started</option>
                  <option value="Active">Active</option>
                  <option value="Completed">Completed</option>
                </select>
              </div>

              {/* Save and Discard Button */}
              <div className="flex justify-around my-4 mx-32">
                <button
                  type="submit"
                  value="save"
                  className="bg-[#616675] text-center px-3 py-1 rounded-lg text-xl"
                >
                  Save
                </button>
                <button
                  className="bg-[#616675] text-center px-2 py-1 rounded-lg text-xl"
                  onClick={closeModal}
                >
                  Discard
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SprintForm;
